import React, {Component} from 'react';
import {connect} from "react-redux";
import {getOrderForm} from "../../store/actions/orderForm";
import {ClipLoader} from "react-spinners";
import {getProducts} from "../../store/actions/products";
import Price from "../../shared/price";
import Stripe from "../Stripe/Stripe";
import {addPaymentMethodAndBuyOrderForm, createPaymentIntent} from "../../store/actions/transactions";
import styles from "./OrderForm.module.css";
import ThankYou from "../ThankYou/ThankYou";
import axios from "axios";

class OrderForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            result: null,
            fromCurrency: "USD",
            toCurrency: "AUD",
            currencies: []
        };
    }


    componentDidMount() {
        const id = this.props.match.params.id;
        this.props.getOrderForm(id);
        if (!this.props.products) {
            this.props.getProducts();
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!prevProps.orderForm && this.props.orderForm) {
            if (!this.props.paymentIntent && this.props.orderForm.state !== "SUCCESS" && this.props.orderForm.paymentProvider === "STRIPE") {
                this.props.createPaymentIntent(this.props.orderForm.transactionId);
                axios.get(
                    `https://api.openrates.io/latest?base=${this.state.fromCurrency}&symbols=${this.state.toCurrency}`
                ).then(response => {
                        const result = this.props.orderForm.price * response.data.rates[this.state.toCurrency];
                        this.setState({result: result});
                    }).catch(error => {
                        console.log("Oops..", error.message);
                    });
            }
        }
    }

    buy(token) {
        const orderForm = this.props.orderForm;
        if (orderForm.paymentProvider === "STRIPE") {
            this.props.buy(token, orderForm.transactionId)
        } else {
            this.props.buy(orderForm.userId, token, orderForm.paymentProvider, orderForm.transactionId)
        }
    }

    render() {
        const orderForm = this.props.orderForm;
        const products = this.props.products;
        if (!orderForm || !products) {
            return null;
        }
        const product = products[orderForm.productId];

        let imgUrl;
        if (this.props.productGroups[product.group].links) {
            imgUrl = this.props.productGroups[product.group].links.thumbnail;
        }

        let form = <h2>Something went wrong, please contact customer support</h2>;
        if (orderForm.paymentProvider === "BRAINTREE") {
            form = <div>Braintree order form</div>
        } else if (orderForm.paymentProvider === "STRIPE" && this.props.paymentIntent) {


            form = <Stripe intent={this.props.paymentIntent} className={styles.stripeRoot}
                           onSubmit={(token) => this.buy(token)}/>
        }

        let body = null;
        if (this.props.transactions) {
            body = <ThankYou/>
        } else {
            if (!this.props.loading) {
                body = (
                    <div className={styles.orderformProduct}>
                        <img src={imgUrl} alt="product thumbnail" className="tile-img"/>
                        <div className={styles.orderformDescription}>
                            <h3>{product.descriptiveName} {
                                orderForm.productId === 92 ? (<Price price={this.state.result}/>)
                                    : (<Price price={orderForm.price}/>)}
                                {orderForm.productId === 92 ? " AUD" : null} </h3>
                            <p>{product.description}</p>
                        </div>
                        <br/><br/>
                        {form}
                    </div>
                )
            }
        }

        return (
            <React.Fragment>
                {this.props.loading ? <ClipLoader sizeUnit="px" size={200} color="black"/> : null}
                {body}
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        loading: state.orderFormReducer.loading || state.productsReducer.loading || state.transactionsReducer.loading,
        orderForm: state.orderFormReducer.orderForm,
        error: state.orderFormReducer.error,
        products: state.productsReducer.indexedProduct,
        productGroups: state.productsReducer.indexedProducts,
        transactionError: state.transactionsReducer.error,
        transactions: state.transactionsReducer.finished,
        paymentIntent: state.transactionsReducer.paymentIntent
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getOrderForm: (id) => dispatch(getOrderForm(id)),
        getProducts: () => dispatch(getProducts()),
        buy: (userId, token, provider, transactionId) => dispatch(addPaymentMethodAndBuyOrderForm(userId, token, provider, [transactionId])),
        createPaymentIntent: (transaction) => dispatch(createPaymentIntent(transaction))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderForm);